"use client"
import {
  __spreadProps,
  __spreadValues
} from "./chunk-EUPSTO3P.js";

// src/useSuspenseQuery.ts
import {
  parseQueryArgs,
  useQuery
} from "@tanstack/react-query";
function useSuspenseQuery(arg1, arg2, arg3) {
  return useQuery(__spreadProps(__spreadValues({}, parseQueryArgs(arg1, arg2, arg3)), {
    suspense: true
  }));
}

export {
  useSuspenseQuery
};
//# sourceMappingURL=chunk-PRFF2FTF.js.map